import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ArrearsDrillDownEntityState, arrearsDrillDownEntityAdapter, ArrearsDrillDownInstance } from '../reducers/arrears-drilldown.reducer';

const selectDrillDownEntityState = createFeatureSelector<ArrearsDrillDownEntityState>('debtAnalysisDrillDown');

export const { selectEntities } = arrearsDrillDownEntityAdapter.getSelectors(selectDrillDownEntityState);

export const selectDrillDownState = (widgetId: string) => createSelector(selectEntities, (entities) => entities[widgetId.toString()]);

